<template>
    <a :href="file.url" target="_blank" class="embed-file-document inline-block cursor-pointer rounded bg-white px-5 py-3 shadow shadow-zinc-400 hover:bg-zinc-50">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" data-slot="icon" class="mr-1 inline h-6 w-5 -translate-y-0.5 leading-7">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
        </svg>
        <span class="text-base sm:text-lg">{{ file.name }}.{{ file.extension }}</span>
    </a>
</template>

<script>
export default {
    name: 'EmbedFileDocument',
    props: ['file']
};
</script>
